import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

const BuildingsListPage = lazy(() => import('src/pages/buildings/list'));
const BuildingNewPage = lazy(() => import('src/pages/buildings/new'));
const BuildingEditPage = lazy(() => import('src/pages/buildings/edit'));
const BuildingDetailsPage = lazy(() => import('src/pages/buildings/details'));
const BuildingFileNewPage = lazy(() => import('src/pages/buildings/file-new'));
const BuildingFileDetailsPage = lazy(() => import('src/pages/buildings/file-details'));
const BuildingFileEditPage = lazy(() => import('src/pages/buildings/file-edit'));

const VIEWER_ROLES = [ROLES.BUILDINGS_ADMIN, ROLES.BUILDINGS_EDITOR, ROLES.BUILDINGS_VIEWER];
const EDITOR_ROLES = [ROLES.BUILDINGS_ADMIN, ROLES.BUILDINGS_EDITOR];

const guardedList = (
  <RoleBasedGuard navigateTo roles={VIEWER_ROLES}>
    <BuildingsListPage />
  </RoleBasedGuard>
);

const guardedNew = (
  <RoleBasedGuard navigateTo roles={EDITOR_ROLES}>
    <BuildingNewPage />
  </RoleBasedGuard>
);

const guardedEdit = (
  <RoleBasedGuard navigateTo roles={EDITOR_ROLES}>
    <BuildingEditPage />
  </RoleBasedGuard>
);

const guardedDetails = (
  <RoleBasedGuard navigateTo roles={VIEWER_ROLES}>
    <BuildingDetailsPage />
  </RoleBasedGuard>
);

const guardedFileNew = (
  <RoleBasedGuard navigateTo roles={EDITOR_ROLES}>
    <BuildingFileNewPage />
  </RoleBasedGuard>
);

const guardedFileDetails = (
  <RoleBasedGuard navigateTo roles={VIEWER_ROLES}>
    <BuildingFileDetailsPage />
  </RoleBasedGuard>
);

const guardedFileEdit = (
  <RoleBasedGuard navigateTo roles={EDITOR_ROLES}>
    <BuildingFileEditPage />
  </RoleBasedGuard>
);

export const buildingRoutes = [
  {
    path: 'buildings',
    children: [
      { element: guardedList, index: true },
      { path: 'new', element: guardedNew },
      { path: ':id/edit', element: guardedEdit },
      { path: ':id/files/new', element: guardedFileNew },
      { path: ':id/files/:fileId/edit', element: guardedFileEdit },
      { path: ':id/files/:fileId', element: guardedFileDetails },
      { path: ':id', element: guardedDetails },
    ],
  },
];
